import { render, staticRenderFns } from "./KendoGridColumnsEditorDialog.vue?vue&type=template&id=01552018"
import script from "./KendoGridColumnsEditorDialog.vue?vue&type=script&lang=ts"
export * from "./KendoGridColumnsEditorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports